let globalMMTimeout = 0

class PvtMegamenuItem extends HTMLElement {
  constructor() {
    super()
    this.$detail = this.querySelector('details')
    this.$trigger = this.$detail.querySelector('summary')
    this.$dropdown = this.$detail.querySelector(
      '.pivot-megamenu-item__dropdown'
    )
    this.$aside = this.querySelector('.pivot-megamenu-item__main-aside ul')
    this.$subItemsWrapper = this.querySelector('.pivot-megamenu-item__subitems')
    this.$parent = this.closest('.shopify-section')
    this.openMode = this.dataset.openMode
    this.sidemenuBehavior = this.dataset.sidemenuBehavior
    this.isTouch = window.matchMedia('(hover:none)')
    this.hideDebounce = 0

    // Cerrar el menu al esconder el header
    const observer = new MutationObserver(entries => {
      entries.forEach(entry => {
        if (!this.$detail.open) return
        const clss = this.$parent.getAttribute('class')
        if (clss === entry.oldValue) return
        this.$detail.open = !this.$parent.classList.contains(
          'shopify-section-header-hidden'
        )
      })
    })
    observer.observe(this.$parent, {
      attributeFilter: ['class'],
      attributes: true,
      attributeOldValue: true,
    })

    // Cerrar al clickear fuera
    this.$dropdown.addEventListener(
      'mouseleave',
      e => {
        if (e.target === this.$dropdown) {
          this.$detail.open = false
        }
      },
      false
    )

    // Hover en los elementos internos
    const openMenu = e => {
      e.preventDefault()
      clearTimeout(globalMMTimeout)
      globalMMTimeout = setTimeout(() => {
        const $newMenuActive = this.$aside.querySelector(
          '.pivot-megamenu-item__main-aside-link:hover'
        )
        if (!$newMenuActive) return

        const $currentMenuActive = this.$aside.querySelector('.active')
        const $currentGridActive =
          this.$subItemsWrapper.querySelector('.active')

        if ($currentMenuActive) $currentMenuActive.classList.remove('active')
        if ($currentGridActive) $currentGridActive.classList.remove('active')

        $newMenuActive.classList.add('active')
        this.$subItemsWrapper
          .querySelector(`#${$newMenuActive.dataset.item}`)
          ?.classList.add('active')
      }, 70)
    }
    this.$aside.addEventListener(
      this.sidemenuBehavior === 'navigate' && !this.isTouch.matches
        ? 'mouseover'
        : 'click',
      openMenu
    )

    this.$subItemsWrapper.addEventListener('mouseover', () =>
      clearTimeout(globalMMTimeout)
    )
    // Hover en el trigger
    if (this.openMode === 'hover')
      this.$trigger.addEventListener('mouseover', () => {
        this.$detail.open = true
      })

    // Ocultar al salir del trigger
    this.$trigger.addEventListener('mouseleave', e => {
      this.hideDebounce = setTimeout(() => {
        this.$detail.open = false
      }, 250)
    })
    this.$dropdown.addEventListener('mouseover', () => {
      if (this.hideDebounce) clearTimeout(this.hideDebounce)
    })
  }
}
if (!customElements.get('pvt-megamenu-item')) {
  customElements.define('pvt-megamenu-item', PvtMegamenuItem)

  // Abrir/cerrar otros elementos del megamenú
  const stickyHeader = document.querySelector('sticky-header')
  const summaries = document.querySelectorAll(
    'sticky-header .list-menu--inline > li > header-menu > details, sticky-header .list-menu--inline > li > pvt-megamenu-item > details'
  )

  const openObserver = new MutationObserver(entries =>
    entries.forEach(entry => {
      console.log('entry', entry)
      const parentName = entry.target.parentElement.tagName.toLowerCase()
      console.log('ParentName', parentName)
      if (
        !entry.target.open ||
        (parentName != 'header-menu' && parentName != 'pvt-megamenu-item')
      )
        return
      // console.log('Abrimos', entry.target)
      summaries.forEach(el => {
        console.log('Elemento', el)
        if (el !== entry.target) el.open = false
      })
    })
  )

  summaries.forEach(summary => {
    summary
      .querySelector('summary')
      .addEventListener('mouseover', e => (summary.open = true))
    if (summary.querySelector('pivot-megamenu-item')) return
    summary
      .querySelector('.mega-menu__content')
      ?.addEventListener('mouseleave', e => (summary.open = false))
  })

  const linksItem = stickyHeader.querySelectorAll(
    'li a.link.header__menu-item.list-menu__item'
  )

  console.log({ linksItem })
  linksItem.forEach(linkItem => {
    linkItem.addEventListener('mouseover', e => {
      summaries.forEach(summary => (summary.open = false))
    })
  })

  // Subscribir todos los summaries
  openObserver.observe(stickyHeader, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  })
}

